import { useId } from 'react';

import HistoryEntryRow from './HistoryEntryRow';
import HistoryStatus from './HistoryStatus';
import { toHistoryEntryView } from './private-event-history-rows';
import { usePrivateEventHistory } from './use-private-event-history';

const NOTE = { padding: '8px 16px 14px', margin: 0, fontSize: 12, color: 'var(--nb-subtle)' };

/** Every change ever saved to the event, newest first. All of it, nothing
 *  collapsed: leadership reads this to see what moved and when. */
export default function PrivateEventHistoryCard({ eventId }: { eventId: string }) {
  const headingId = useId();
  const history = usePrivateEventHistory(eventId);
  const entries = (history.data ?? []).map(toHistoryEntryView);
  return (
    <section
      aria-labelledby={headingId}
      className="nb-card"
      style={{ padding: 0, overflow: 'hidden' }}
    >
      <div style={{ padding: '12px 16px 8px', display: 'flex', alignItems: 'baseline', gap: 8 }}>
        <h3
          id={headingId}
          className="nb-eyebrow"
          style={{ margin: 0, fontSize: 10, color: 'var(--nb-muted)' }}
        >
          Change history
        </h3>
        <span style={{ fontSize: 10.5, color: 'var(--nb-subtle)' }}>every edit, forever</span>
      </div>
      <HistoryStatus history={history} />
      {history.isSuccess && entries.length === 0 && <p style={NOTE}>No changes recorded yet.</p>}
      <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {entries.map((entry) => (
          <HistoryEntryRow key={entry.id} entry={entry} />
        ))}
      </ul>
    </section>
  );
}
